<template>
  <div>
    <!-- Inline -->
    <div class="row q-mb-md">
      <!-- Filters hide/show button -->
      <div class="col-6">
        <div class="row" style="justify-content: flex-start">
          <div>
            <q-btn
              @click="showFilters();"
              :text-color="hideFilters ? 'grey-5' : 'white'"
              class="neutral-btn ctrl-button btn-compact"
              :class="{ primary: !hideFilters }"
              icon="filter_list"
              :icon-right="hideFilters ? 'keyboard_arrow_up' : 'keyboard_arrow_down'"
            />
          </div>
          <!-- Searchfield -->
          <div class="q-ml-md" style="flex-grow: 1">
            <q-input
              color="grey-5"
              v-model="searchTerm"
              @input="applyFilters"
              :placeholder="getString(null, 'Search directly by search term', 'Zoek direct op term')"
            />
          </div>
        </div>
      </div>
    </div>
    <!-- Filters block -->
    <transition name="fade">
    <div v-if="!hideFilters" class="table-block q-mb-md">
      <div class="row q-pa-md" style="justify-content: space-between;">
        <!-- Searchfield -->
        <div class="col-6 q-pa-md">
          <q-input color="primary"
            v-model="filters.term"
            @input="applyFilters"
          :float-label="getString(null, 'Search term', 'Zoekterm')"/>
        </div>
        <!-- Searchfield -->
        <div class="col-6 q-pa-md">
          <q-select
            @input="applyFilters"
            v-model="filters.type"
            :options="[{ label: 'Regular', value: 'regular' }, { label: 'Downloads', value: 'downloads' }]"
            float-label="Type"/>
        </div>
      </div>
      <div class="row q-pa-md" style="justify-content: space-between;">
        <div class="q-pa-md" style="vertical-align: middle;">
          <q-btn
            :disable="!activeFilters"
            @click="resetFilters()"
            class="capitalize ctrl-button"
            :color="activeFilters ? 'primary' : 'grey-4'"
            label="Reset"
          />
        </div>
      </div>
    </div>
    </transition>
    <table-overview
      :endpoint="'searchlog'"
      :responseFormat="'history'"
      :noDataFormat="'history'"
      :columns="columns"
      :permission="'searchlog'"
      :module="'searchlog'"
      :selectable="false"
    >
    </table-overview>
  </div>
</template>

<script>
import TableOverview from '@/components/overview/TableOverview.vue';
import filtersMixin from '@/mixins/tables/filtersMixin';
import getString from '@/helpers/GetStrings';

export default {
  components: {
    TableOverview,
  },
  mixins: [
    filtersMixin,
  ],
  data() {
    return {
      filters: {
        term: '',
        type: null,
      },
      rowSelection: [],
      searchTerm: '',
      isLoading: false,
      columns: [
        {
          name: '__slot:general-term',
          sortField: 'term',
          title: getString(null, 'Term', 'Term'),
          titleClass: 'text-left sortable vcol-m',
          dataClass: 'text-left vcol-s text-ellipsis',
        },
        {
          name: 'type',
          sortField: 'type',
          title: getString(null, 'Type', 'Type'),
          titleClass: 'text-left sortable vcol-m',
          dataClass: 'text-left vcol-s text-ellipsis',
        },
        {
          name: '__slot:search_params',
          title: getString(null, 'Params', 'Params'),
          titleClass: 'text-left sortable vcol-m',
          dataClass: 'text-left vcol-s text-ellipsis',
        },
        {
          name: 'num_searches',
          sortField: 'searches',
          title: getString(null, 'Searches', 'Searches'),
          titleClass: 'text-left sortable vcol-s',
          dataClass: 'text-left vcol-s text-ellipsis',
        },
        {
          name: 'results',
          sortField: 'results',
          title: getString(null, 'Results', 'Results'),
          titleClass: 'text-left sortable vcol-s',
          dataClass: 'text-left vcol-s text-ellipsis',
        },
      ],
      hideFilters: true,
      preferences: {
        page: 1,
        perPage: 10,
        sortField: null,
        sortOrder: null,
      },
    };
  },
  methods: {
    getString,
  },
};
</script>

<style lang="stylus" scoped>
@import '~variables';
</style>
